import React from 'react';
import { Calendar, Loader2 } from 'lucide-react';

// Sticky date-selection bar shown above the room grid. Purely presentational —
// all state lives in the parent Rooms.jsx so it can trigger availability
// re-fetch on any change.
export const DateSelectionBar = ({
  checkIn,
  checkOut,
  adults,
  children,
  loading,
  availability,
  today,
  minCheckout,
  onCheckInChange,
  onCheckOutChange,
  onAdultsChange,
  onChildrenChange,
}) => (
  <div className="bg-white rounded-2xl shadow-lg p-6 mb-12 max-w-4xl mx-auto" data-testid="rooms-date-bar">
    <div className="flex items-center gap-2 mb-4">
      <Calendar className="text-orange-500" size={24} />
      <h3 className="text-lg font-semibold text-gray-900">Select dates to see live prices</h3>
    </div>
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">Check-in</label>
        <input
          type="date"
          value={checkIn}
          onChange={(e) => onCheckInChange(e.target.value)}
          min={today}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm"
          data-testid="rooms-checkin-input"
        />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">Check-out</label>
        <input
          type="date"
          value={checkOut}
          onChange={(e) => onCheckOutChange(e.target.value)}
          min={minCheckout}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm"
          data-testid="rooms-checkout-input"
        />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">Adults</label>
        <select
          value={adults}
          onChange={(e) => onAdultsChange(parseInt(e.target.value))}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 text-sm"
          data-testid="rooms-adults-select"
        >
          {[1, 2, 3, 4, 5, 6].map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">Children</label>
        <select
          value={children}
          onChange={(e) => onChildrenChange(parseInt(e.target.value))}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 text-sm"
          data-testid="rooms-children-select"
        >
          {[0, 1, 2, 3, 4].map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
      </div>
      <div className="flex items-end">
        {loading ? (
          <div className="w-full flex items-center justify-center py-2 text-orange-500">
            <Loader2 size={20} className="animate-spin mr-2" />
            <span className="text-sm">Loading...</span>
          </div>
        ) : availability ? (
          <div className="w-full text-center py-2">
            <span className="text-green-600 font-semibold text-sm">✓ {availability.num_nights} nights</span>
          </div>
        ) : null}
      </div>
    </div>
    {availability && (
      <div className="mt-4 pt-4 border-t flex items-center justify-between text-sm">
        <span className="text-gray-600">
          Showing prices for <strong>{availability.num_nights} nights</strong> • {adults} adults{children > 0 ? `, ${children} children` : ''}
        </span>
        <span className="text-xs text-gray-400">Live rates from Beds24</span>
      </div>
    )}
  </div>
);
